/**
 * İstemci ayarlarının SESSİZCE değişmemesi gereken kısmı.
 *
 * NEDEN AYRI DOSYA: `lib/supabase.ts` ve `lib/sentry.ts` `import.meta.env`
 * kullanıyor. ts-jest bunu derleyemiyor, bu yüzden iki modül de bütün
 * testlerde sahteleniyor (`src/test/setup.ts`) ve içlerindeki hiçbir ayar
 * sınanamıyordu. Mutasyon denetimi üç ayarı bozdu, üçü de hayatta kaldı:
 *
 *   autoRefreshToken: true → false   oturum süresi dolunca sessizce kopar
 *   persistSession: true   → false   kullanıcı HER YENİLEMEDE çıkış yapar
 *   blockAllMedia: true    → false   oturum kaydında medya maskelenmez
 *
 * Sabitler buraya taşındı; değerleri DEĞİŞMEDİ. Bu dosyada `import.meta`
 * yok, dolayısıyla `src/test/istemci-yapilandirmasi.test.ts` onları
 * doğrudan okuyabiliyor.
 *
 * Ortama bağlı olan ayarlar (`storage`, `detectSessionInUrl`,
 * `environment`, `tracesSampleRate`) burada DEĞİL — onlar Capacitor'a ve
 * `import.meta.env`e bakıyor, kendi dosyalarında kaldılar ve hâlâ
 * sınanmıyorlar.
 */

/** Supabase oturum davranışı. Kullanıcının oturumda kalmasını sağlar. */
export const AUTH_SABITLERI = {
  /** Belirteç süresi dolmadan kendiliğinden tazelenir. */
  autoRefreshToken: true,
  /** Oturum depoya yazılır; sayfa yenilendiğinde kullanıcı düşmez. */
  persistSession: true,
} as const

/** Sentry oturum kaydı gizliliği (KVKK). */
export const OTURUM_KAYDI_AYARLARI = {
  /** Ekrandaki bütün metin maskelenir. */
  maskAllText: true,
  /** Görsel ve video içerikleri kayda girmez. */
  blockAllMedia: true,
} as const
